import { render, staticRenderFns } from "./imprRequest.vue?vue&type=template&id=76380b9f"
import script from "./imprRequest.vue?vue&type=script&lang=js"
export * from "./imprRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76380b9f')) {
      api.createRecord('76380b9f', component.options)
    } else {
      api.reload('76380b9f', component.options)
    }
    module.hot.accept("./imprRequest.vue?vue&type=template&id=76380b9f", function () {
      api.rerender('76380b9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprRequest.vue"
export default component.exports